export { default } from './OrderDetailsPopup';
